var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZhFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H513V342H0V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8 239.2L217.1 223.6L199.2 228L211.1 213.9L201.4 198.3L218.5 205.2L230.3 191.1L229 209.5L246.1 216.4L228.2 220.8L226.8 239.2ZM290.6 81.9999L280.5 97.3999L292.1 111.7L274.4 106.9L264.3 122.4L263.3 104L245.6 99.1999L262.8 92.5999L261.8 74.1999L273.4 88.4999L290.6 81.9999ZM236.2 25.3999L234.2 43.6999L251 51.2999L233 55.0999L231 73.3999L221.8 57.3999L203.9 61.1999L216.2 47.4999L207 31.5999L223.8 39.0999L236.2 25.3999ZM292.8 161.8L277.9 172.7L283.7 190.2L268.8 179.4L253.9 190.4L259.5 172.8L244.6 162.1L263 162L268.6 144.4L274.4 161.9L292.8 161.8ZM115 46.2999L132.3 99.7999H188.5L143.1 132.7L160.4 186.2L115 153.2L69.5 186.2L86.9 132.7L41.4 99.7999H97.7L115 46.2999Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhFlag);
export default __webpack_public_path__ + "static/media/zh-flag.8ce6c5a70dff299eae1491d1ccf992ff.svg";
export { ForwardRef as ReactComponent };